var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1WirelessPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 42.67v13.66A5.67 5.67 0 0153.33 62H22.67A5.67 5.67 0 0117 56.33V42.67c0-3.13.54-5.67 3.67-5.67H22v12a8 8 0 008 8h16a8 8 0 008-8V37h1.33c3.13 0 3.67 2.54 3.67 5.67zM26 49V17a4 4 0 014-4h16a4 4 0 014 4v32a4 4 0 01-4 4H30a4 4 0 01-4-4zm4 0h16V17H30v32zm8-7.5a2 2 0 100 4 2 2 0 000-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Wireless_phone.a73b9e5d.svg";
export { SvgH1WirelessPhone as ReactComponent };